import React from 'react';

const overlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: 'rgba(0,0,0,0.6)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 9999,
};

const boxStyle = {
  background: '#fff',
  padding: 12,
  borderRadius: 6,
  maxWidth: '90%',
  maxHeight: '90%',
  boxShadow: '0 8px 24px rgba(0,0,0,0.4)',
  display: 'flex',
  flexDirection: 'column',
  gap: 8,
};

const imgStyle = {
  maxWidth: '100%',
  maxHeight: '75vh',
  objectFit: 'contain',
  borderRadius: 4,
};

const closeBtnStyle = {
  alignSelf: 'flex-end',
  background: 'transparent',
  border: 'none',
  fontSize: 18,
  cursor: 'pointer'
};

export default function ImagePreviewModal({ url, onClose, alt = 'Comprobante' }) {
  if (!url) return null;
  return (
    <div style={overlayStyle} onClick={onClose}>
      <div style={boxStyle} onClick={(e) => e.stopPropagation()}>
        <button aria-label="Cerrar" style={closeBtnStyle} onClick={onClose}>✕</button>
        <img src={url} alt={alt} style={imgStyle} />
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <a href={url} target="_blank" rel="noopener noreferrer" style={{ fontSize: 13 }}>Abrir en nueva pestaña</a>
        </div>
      </div>
    </div>
  );
}
